// @flow

import * as React from 'react'
import { Dropdown, List, Divider, Icon, Label } from 'semantic-ui-react'

import type { User } from '../store/manage-users'

type Props = {|
  onAddUser: (user: string) => void,
  onRemoveUser: (user: string) => void,
  users: Array<User>,
  systemUsers: Array<User>,
  currentUser: string,
  isAdmin: boolean,
|}

const UsersSection = (props: Props) => {
  function addUserHandler(e, { value }) {
    props.onAddUser(value)
  }

  function removeUserHandler(username) {
    return (e, data) => {
      props.onRemoveUser(username)
    }
  }

  let users = []
  for (let user of props.users) {
    users.push(
      <List.Item key={'user-' + user.username}>
        <List.Content>
          <Label basic>
            <Icon name="user" />
            {`${user.username || ''} (${user.role || ''})`}
            {user.username !== 'admin' &&
              user.username !== props.currentUser && <Icon name="delete" onClick={removeUserHandler(user.username)} />}
          </Label>
        </List.Content>
      </List.Item>
    )
  }
  if (props.isAdmin) {
    let sUsers = props.users.map(el => el.username)
    let userOptions = props.systemUsers.filter(el => sUsers.indexOf(el.username) === -1).map(user => ({
      key: user.username,
      value: user.username,
      text: `${user.username || ''} (${user.role || ''})`,
    }))

    return (
      <div className="column">
        <Divider horizontal>Gestione Utenti</Divider>
        <List>{users}</List>
        <Dropdown
          button
          labeled
          scrolling
          icon="add"
          className="green icon mini"
          style={{ zIndex: '800', margin: '1ex' }}
          disabled={userOptions.length === 0}
          options={userOptions}
          selectOnBlur={false}
          text="Aggiungi Utente..."
          noResultsMessage="Nessun risultato."
          onChange={addUserHandler}
        />
      </div>
    )
  } else {
    return <span style={{ display: 'none' }} />
  }
}

export default UsersSection



// WEBPACK FOOTER //
// ./src/campaigns/users-section.js